import { HttpClient } from '@angular/common/http';
import { TranslateLoader } from '@ngx-translate/core';
import { Observable, forkJoin, of } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import { PT_FALLBACK } from './pt-fallback';

const RESOURCES: Array<(lang: string) => string> = [(lang: string) => `./assets/i18n/${lang}/all.json`];

export class CustomMultiTranslateHttpLoader implements TranslateLoader {
  constructor(private http: HttpClient) {}

  getTranslation(lang: string): Observable<any> {
    const reqs = RESOURCES.map(make =>
      this.http.get<Record<string, any>>(make(lang)).pipe(
        catchError(() => of({})), // 404 -> {}
      ),
    );

    return forkJoin(reqs).pipe(
      map(parts => {
        const merged = parts.reduce((acc, part) => safeMerge(acc, part), {} as any);
        // Se o resultado ficou vazio (todos os JSONs falharam),
        // injectar o fallback PT-PT para garantir mensagens legíveis
        if (Object.keys(merged).length === 0) {
          return unflatten(PT_FALLBACK);
        }
        return merged;
      }),
    );
  }
}

function isPlainObject(x: any): x is Record<string, any> {
  return x != null && typeof x === 'object' && !Array.isArray(x);
}

function safeMerge(target: any, source: any) {
  if (!isPlainObject(source)) return target;
  for (const key of Object.keys(source)) {
    const sv = source[key];
    if (isPlainObject(sv)) {
      target[key] = safeMerge(isPlainObject(target[key]) ? target[key] : {}, sv);
    } else {
      target[key] = sv;
    }
  }
  return target;
}

export function HttpLoaderFactory(http: HttpClient): TranslateLoader {
  return new CustomMultiTranslateHttpLoader(http);
}

/**
 * Converte um Record<string, string> de chaves flat (ex: 'COMMON.ALERTS.ATTENTION')
 * para a estrutura aninhada que o ngx-translate espera.
 */
function unflatten(flat: Record<string, string>): Record<string, any> {
  const result: Record<string, any> = {};
  for (const [key, value] of Object.entries(flat)) {
    const parts = key.split('.');
    let current = result;
    for (let i = 0; i < parts.length - 1; i++) {
      if (!current[parts[i]] || typeof current[parts[i]] !== 'object') {
        current[parts[i]] = {};
      }
      current = current[parts[i]];
    }
    current[parts[parts.length - 1]] = value;
  }
  return result;
}
